export default __webpack_public_path__ + "media/music/672cfed514e7d2d3011d0631d4832591.mp3";